import React from 'react'
import Axios from 'axios'
import './application-modal.css'
import { baseUrl } from '../assets/Animations'
import {createPostInterviewTask} from '../AdminWorkflows/WorkflowModels'

const ApplicationModal = (props) => {

    const closeApplication = (id) => {
        if(id === "application-modal-wrapper") {
            props.setApplication(false)
        }
    }
    const deny = async () => {
        props.toggleLoadingScreen('Sending denial...')
        Axios.put(`${baseUrl}/sendadenial`, {
            application: props.application
        })
        .then(response => {
            props.setApplication(false)
            props.deleteApplication(props.application.id)

        })
        .catch(err => {
            props.toggleLoadingScreen('close')
            alert(err)
            props.setError({message: err.response.data, status: err.response.status})
        })
    }
    const accept = async () => {
        props.toggleLoadingScreen('Accepting canidate...')
        Axios.put(`${baseUrl}/sendanaccept`, {
            application: props.application,
        })
        .then(response => {
            createPostInterviewTask(props.application.key1app, props.application.key2app, props.application.key21app, props.application.key14app, props.application.key13app, props.pushItem)
            //props.setApplication(false)
            //props.toggleLoadingScreen()
            console.log(props.application.id)
            props.deleteApplication(props.application.id)
        })
        .catch(err => {
            props.toggleLoadingScreen('close')
            alert(err)
            props.setError({message: err.response.data, status: err.response.status})
        })
    }

    const deleteWithTrash = () => {
        props.toggleLoadingScreen('Deleting application...')
        props.setApplication(false)
        props.deleteApplication(props.application.id)
    }
    return(
        <div className="application-modal-wrapper" id="application-modal-wrapper" onClick={(e) => closeApplication(e.target.id)}>
            <div className="application-modal">
                <div className="app-x-wrapper">
                    <div className="app-x" onClick={() => props.setApplication(false)}>x</div>
                </div>
                <div className='application-modal__pretty-header'>
                    <div className="app-name">{props.application.key1app} {props.application.key2app}</div>
                    <div className='application-modal__inst-list'>
                        {props.application.key13app.map((inst) => (
                            <p className='app-modal__inst-list__each-inst'>{inst.name}</p>
                        ))}
                    </div>
                    <div className="app-schoolname">~{props.application.key14app}~</div>
                </div>
                <div className='fifty-fifty-wrapper'>
                    <div className='app-modal__fifty-fifty left-fifty-fifty'>
                        <div className='contact-header'>CONTACT</div>
                        <div className="app-contact-info">{props.application.key3app}</div>
                        <div className="app-contact-info">{props.application.key4app}</div>
                        <div className="app-contact-info">{props.application.key5app}</div>
                        <div className='contact-header'>DETAILS</div>
                        <div><strong>Areas:</strong> {props.application.key22app}</div>
                        <div><strong>XP:</strong> {props.application.key6app} years</div>
                        <div><strong>Longevity:</strong> {props.application.ke7app} years</div>
                        <div><strong>Drive Radius:</strong> {props.application.key8app} miles</div>
                        <div><strong>Desired Studio Size:</strong> {props.application.key9app} students</div>
                        <div className='app-modal__check-wrapper'><strong className='app-modal__checkmark-title' style={props.application.key17app === 'true' ? {color: 'green'} : {color: 'red'}}>Background Check:</strong>
                            {props.application.key17app === 'true' ? <img className='app-modal__checkmark' src='./right.svg'/> : <img className='app-modal__checkmark' src='./right-empty.svg' /> }
                        </div>
                        <div className='app-modal__check-wrapper'><strong className='app-modal__checkmark-title' style={props.application.key18app === 'true' ? {color: 'green'} : {color: 'red'}}>Has Vehicle:</strong>
                            {props.application.key18app === 'true' ? <img className='app-modal__checkmark' src='./right.svg'/> : <img className='app-modal__checkmark' src='./right-empty.svg' /> }
                        </div>
                        <div className='app-modal__check-wrapper'><strong className='app-modal__checkmark-title' style={props.application.key19app === 'true' ? {color: 'green'} : {color: 'red'}}>Driver's License:</strong>
                            {props.application.key19app === 'true' ? <img className='app-modal__checkmark' src='./right.svg'/> : <img className='app-modal__checkmark' src='./right-empty.svg' /> }
                        </div>
                        <div className='contact-header'>EDUCATION</div>
                        <div className="app-cover-letter">{props.application.key11app}</div>
                    </div>
                    <div className='app-modal__fifty-fifty'>
                        <div className='contact-header'>COVER LETTER</div>
                        <div className="app-cover-letter">{props.application.key10app}</div>
                        <div className='contact-header'>EXPERIENCE</div>
                        <div className="app-cover-letter">{props.application.key12app}</div>
                    </div>
                </div>
                <div className='app-cover__grey-line'></div>
                <div className="education-wrapper">
                    <strong>LINKS:</strong>
                    <div>{props.application.key20app}</div>
                </div>
                <div className="education-wrapper">
                    <strong>REFERENCES:</strong>
                    <div>{props.application.key21app}</div>
                </div>
                <div className="app-button-wrapper">
                    <div className="app-delete-trashcan" onClick={() => deleteWithTrash()}></div>
                    {/* <div className="app-deny-button" onClick={() => deny()}>Deny</div>
                    <div className="app-accept-button" onClick={() => accept()}>I'm Interested</div> */}
                </div>
            </div>
        </div>
    )
}
export default ApplicationModal;